import type {PerkCard as PerkCardType} from '@cohort/components-xps/components/cards/PerkCard';
import PerkCard from '@cohort/components-xps/components/cards/PerkCard';
import useInViewTracker from '@cohort/wallet/hooks/inViewTracker';

type TrackedPerkCardProps = {
  perkCard: PerkCardType;
  metadata: Record<string, unknown>;
  className?: string;
};

const TrackedPerkCard: React.FC<TrackedPerkCardProps> = ({perkCard, className, metadata}) => {
  const ref = useInViewTracker('perks.card', metadata);

  return (
    <div ref={ref} className={className}>
      <PerkCard perkCard={perkCard} />
    </div>
  );
};

export default TrackedPerkCard;
